/* Libraries */
import React, {memo} from 'react';
import Image from 'next/image';

/* Components */
import {Grid} from 'ht-styleguide';
import {SkuExtended} from 'types/sku.types';
import ServiceInfoDetails from './ServiceInfoDetails';

/* Styles */
import styles from './serviceinfo.module.scss';

/* Types */
type ServiceInfoProps = {
  sku?: SkuExtended;
  onBook: BaseAnyFunction;
  onRating: BaseAnyFunction;
  onUpsellToggle: BaseAnyFunction;
  onUpsellMore: BaseAnyFunction;
  className: string;
  isPending: boolean;
};

const ServiceInfo = ({sku, onBook, onRating, onUpsellToggle, onUpsellMore, className, isPending}: ServiceInfoProps) => (
  <Grid.FullWidth classes={className} dataTestId="sku-services-info">
    {/* @ts-ignore */}
    <Grid.Row classes={styles.hero}>
      <Grid.Column sm={4} md={8} lg={7}>
        <div className={styles.image}>
          <div style={{position: 'relative', height: '100%', width: '100%'}}>
            <Image priority={true} quality={60} layout="fill" objectFit="cover" alt={sku.name} src={sku?.image || '/'} />
          </div>
        </div>
      </Grid.Column>
      <Grid.Column sm={4} md={8} lg={5}>
        <ServiceInfoDetails
          sku={sku}
          onBook={onBook}
          onRating={onRating}
          className={styles.infoContainer}
          onUpsellMore={onUpsellMore}
          onUpsellToggle={onUpsellToggle}
          isPending={isPending}
        />
      </Grid.Column>
    </Grid.Row>
  </Grid.FullWidth>
);

export default memo(ServiceInfo);
